import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import urTranslation from './locales/ur/translation.json';

const LANGUAGE_KEY = 'pta_rta_language';

const savedLanguage = localStorage.getItem(LANGUAGE_KEY) || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ur: { translation: urTranslation },
    },
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Persist language choice and update document direction
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANGUAGE_KEY, lng);
  document.documentElement.dir = lng === 'ur' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
});

// Apply direction on initial load
document.documentElement.dir = savedLanguage === 'ur' ? 'rtl' : 'ltr';
document.documentElement.lang = savedLanguage;

export default i18n;
